import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Pagination from "../../Services/Pagination";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { setMainLoading, setPageTitle, OpenModal, setErrorBoundry } from "../../Store/reducers/Common";
import { setToastData } from "../../Store/reducers/Toast";
import Modal from "../../Services/Modal";
import { formatDate } from "../../Services/DateFunc";
import { logoutUser } from "../../Store/reducers/Users";

export default function Notifications() {
  const { accessToken } = useSelector((state) => state.user);
  const [currentPage, setCurrentPage] = useState(1);
  const location = useLocation();
  const [paginationData, setPaginationData] = useState({
    total: 0,
    per_page: 10,
  });
  const [notiList, setNotiList] = useState([]);
  const [currentMessage, setCurrentMessage] = useState("");
  const [isShowMessagePopupOpen, setIsShowMessagePopupOpen] = useState(false);

  const dispatch = useDispatch();
  const parseNotificationMessage = (notification) => {
    if (notification?.message) return notification.message;
    try {
      const parsedData =
        typeof notification?.notification_data === "string"
          ? JSON.parse(notification.notification_data)
          : notification?.notification_data || {};
      return parsedData?.message || parsedData?.title || "New notification";
    } catch (error) {
      return "New notification";
    }
  };

  const fetchUsersList = (pageNo = currentPage) => {
    dispatch(setMainLoading(true));
    PostAxios(`notification/get-user-notification`, {}, accessToken)
      .then(({ data }) => {
        if (data?.code === 401) {
          dispatch(
            setToastData({
              message: `${data?.message} <h3><a href="${process.env.REACT_APP_WEBSITE_URL}">&laquo; Go to website</a></h3>`,
              isHtml: true,
              type: "error",
            })
          );
          dispatch(setErrorBoundry(true));
          dispatch(logoutUser());
        } else if (`${data?.status}` === "1") {
          const fullList = Array.isArray(data?.data) ? data.data : [];
          const mapped = fullList.map((item) => ({
            ...item,
            message: parseNotificationMessage(item),
          }));
          const page = pageNo > 0 ? pageNo : 1;
          const perPage = paginationData.per_page || 10;
          const start = (page - 1) * perPage;
          const pageData = mapped.slice(start, start + perPage);
          setNotiList(pageData);
          setPaginationData({
            total: mapped.length,
            per_page: perPage,
          });
        } else {
          dispatch(
            setToastData({
              message: `${data?.message || "Unable to fetch notifications."} `,
              isHtml: true,
              type: "error",
              showCloseBtn: true,
            })
          );
          
        }
        dispatch(setMainLoading(false));
      })
      .catch((err) => {
        responseCatchFunc(dispatch, err);
      });
  };
  useEffect(() => {
    dispatch(setPageTitle("Notifications"));
    fetchUsersList();
    return () => {
      dispatch(setMainLoading(false));
    };
  }, [location.pathname, accessToken, dispatch]);
  return (
    <>
      <div className="main-form-sec">
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Message</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {notiList.length < 1 && (
                <tr>
                  <td colSpan={4} className="no-records-found">
                    No records found
                  </td>
                </tr>
              )}
              {notiList.length > 0 &&
                notiList.map((v, i) => {
                  return (
                    <tr key={`user-key-${i}`}>
                      <td>{(currentPage - 1) * paginationData.per_page + i + 1}</td>
                      <td>
                        {v.message?.length > 60
                          ? v.message.substring(0, 60) + "..."
                          : v.message}
                      </td>
                      <td>{formatDate(v.created_at || v.published_date || "")}</td>
                      <td>
                        <button
                          type="button"
                          className="btn-blue btn btn-sm ms-2"
                          onClick={() => {
                            dispatch(OpenModal());
                            setIsShowMessagePopupOpen(true);
                            setCurrentMessage(v?.message);
                          }}
                        >
                          <i className="icon-view" title="View"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={currentPage}
          totalCount={paginationData.total}
          pageSize={paginationData.per_page}
          onPageChange={(page) => {
            setCurrentPage(page);
            fetchUsersList(page);
          }}
        />
        {isShowMessagePopupOpen &&
          <Modal classList="popup-main invoice-popup" onClose={() => {
            setIsShowMessagePopupOpen(false);
          }}>
                <div className="full-message">
                    <h3>Message</h3>
                    <div className="message-body">
					 {currentMessage}
                    </div>
				</div>
          </Modal>
        }
      </div>
    </>
  );
}
